import { FormattedMessage, useIntl } from 'react-intl';
import React from 'react';
import bemify from 'bemify-js';

import { StaticImage } from '@zapier/common-components';

import './NextSteps.scss';
import Confetti from '../components/Confetti';
import Paragraph from '../components/Paragraph';
import StepTitle from '../components/StepTitle';

const bem = bemify('next-steps');

const NextStepsSetup = () => {
  const intl = useIntl();

  return (
    <div className={bem()}>
      <div className={bem('__hero')}>
        <StaticImage
          alt="next-steps-emoji"
          className={bem('__image')}
          src="https://cdn.zapier.com/zapier/images/developer-guide/next-steps-emoji.svg"
          title={intl.formatMessage({
            id: 'captions-hero-emoji-title',
            defaultMessage: 'Smiling face',
          })}
        />
        <Confetti />
        <StepTitle>
          <FormattedMessage
            defaultMessage="Congrats! You set up your environment."
            id="headings-environment-setup-success"
          />
        </StepTitle>
      </div>
      <Paragraph>
        <FormattedMessage
          defaultMessage="You've just set up your Zapier development environment! Next, you will create an example app, run your first automated test, and deploy your app to the Zapier platform."
          id="descriptions-next-steps-overview"
        />
      </Paragraph>
    </div>
  );
};

export default NextStepsSetup;
